/** Значение style в объекте стиля */
export default class StyleValue {
  /**
   * @param {*} alignment - Alignment specification
   * @param {*} border - Border specification
   * @param {*} fill - Fill color
   * @param {*} font - Font specification
   */
  constructor({ alignment, border, fill, font }) {
    this.alignment = alignment;
    this.border = border;
    this.fill = fill;
    this.font = font;
  }

  /**
   * Создать объект StyleValue из объекта произвольного типа.
   * @param {unknown} obj
   * @return {StyleValue}
   */
  static fromJSON(obj) {
    if (!obj) return undefined;
    if (typeof obj !== 'object') throw new Error('not an object');
    return new StyleValue(obj);
  }
}
